/* @flow */

import React from 'react';
import PropTypes from 'prop-types';

import { NotFoundError } from 'four-nets/errors/errors';
import { UserStore } from 'four-nets/user/user';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';
import ErrorPage from 'four-nets/errors/error-page';

import ActivationLinkView from './activation-link-view';

class ActivationLinkLoader extends React.PureComponent {
    static contextTypes = {
        userStore: PropTypes.instanceOf(UserStore),
    };

    fetch = (setData, { activationCode }) => {
        return this.context.userStore
            .verifyAccount(activationCode)
            .then(response => {
                const { username } = response.json;
                setData({
                    username,
                });
            })
            .catch(() => {
                return Promise.reject(new NotFoundError());
            });
    };

    renderFetch = ({ loading, error, data }) => {
        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    {data ? <ActivationLinkView /> : null}
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
                activationCode={this.props.match.params.activationCode}
            />
        );
    }
}

export default (ActivationLinkLoader);
